import LoggingOut from '@/components/LoggingOut'
import { logout as apiLogout } from '@/api/api'
import { logger } from '@/logger'
import { EventBus, Events } from '@/eventbus/EventBus'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { useFileListStore } from '@/stores/FileList.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'

export default {
  computed: {
    ...mapStores(
      useFileStoreStore,
      useFileListStore,
      usePrintStoreStore,
      usePrintOrderStore,
      useCheckOutStore
    )
  },
  methods: {
    logout() {
      this.$modal.show(LoggingOut, null, {
        width: 300,
        height: 'auto'
      })
      apiLogout()
        .then(async () => {
          this.rootStore.toggleSideBar(false)
          this.rootStore.logout()

          this.fileStoreStore.clear()
          await this.fileListStore.removeAllFiles()
          this.printOrderStore.resetOrderDetails()
          this.checkOutStore.resetOrderDetails()

          EventBus.emit(Events.LOGGED_OFF)

          this.$nextTick(async () => {
            await this.rootStore.loadTheme('home')
            if (this.$route.name !== 'home') {
              await this.$router.push({ name: 'home' })
            }
            this.rootStore.setHome()

            // Clear shopping cart
            this.printStoreStore.emptyCart()
          })

          this.$modal.hideAll()
        })
        .catch((error) => logger.error(error, this.rootStore.user.uid))
    }
  }
}
